import { Any } from "../fakeTypes";

export type AmountValidator = {
  validate: (integerPart: string, decimalPart: string, opts?: Record<string, Any>) => boolean;
  opts?: Record<string, Any>;
};

export type PropertyType<T, K extends keyof T> = T[K];
